import { getFirebaseAuthService, getFunctionsService } from './krida-auth.js';
import { httpsCallable } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-functions.js";
import { refreshMyTournamentsView } from './my-tournaments-client.js';

let joinTournamentModalElement;
let closeJoinTournamentModalBtn;
let refreshJoinableTournamentsBtn;
let invitedTournamentsListDiv;
let openTournamentsListDiv;

function assignJoinTournamentModalElements() {
    joinTournamentModalElement = document.getElementById('join-tournament-modal');
    if (joinTournamentModalElement) {
        closeJoinTournamentModalBtn = joinTournamentModalElement.querySelector('#close-join-tournament-modal-btn');
        refreshJoinableTournamentsBtn = joinTournamentModalElement.querySelector('#refresh-joinable-tournaments-btn');
        invitedTournamentsListDiv = joinTournamentModalElement.querySelector('#invited-tournaments-list');
        openTournamentsListDiv = joinTournamentModalElement.querySelector('#open-tournaments-list');
    }
}

async function fetchJoinableTournaments() {
    if (!invitedTournamentsListDiv || !openTournamentsListDiv) {
        console.warn('Join Tournament modal list elements not found.');
        return;
    }

    invitedTournamentsListDiv.innerHTML = '<p>Loading invited tournaments...</p>';
    openTournamentsListDiv.innerHTML = '<p>Loading open tournaments...</p>';

    const auth = getFirebaseAuthService();
    if (!auth || !auth.currentUser) {
        invitedTournamentsListDiv.innerHTML = '<p>Please log in to see your tournament invitations.</p>';
        openTournamentsListDiv.innerHTML = '<p>Please log in to see open tournaments.</p>';
        return;
    }

    const functions = getFunctionsService();
    if (!functions) {
        console.error("Functions service not available for fetching tournaments.");
        invitedTournamentsListDiv.innerHTML = '<p>Error: Could not connect to tournament service.</p>';
        openTournamentsListDiv.innerHTML = '<p>Error: Could not connect to tournament service.</p>';
        return;
    }

    try {
        // TODO: Replace 'getJoinableTournaments' with the actual Firebase Function name
        const getTournaments = httpsCallable(functions, 'getJoinableTournaments'); 
        const result = await getTournaments();
        const { invitedTournaments = [], openTournaments = [] } = result.data || {};

        displayTournaments(invitedTournamentsListDiv, invitedTournaments, true);
        displayTournaments(openTournamentsListDiv, openTournaments, false);

    } catch (error) {
        console.error("Error fetching joinable tournaments:", error);
        invitedTournamentsListDiv.innerHTML = `<p>Error loading tournament invitations: ${error.message}</p>`;
        openTournamentsListDiv.innerHTML = `<p>Error loading open tournaments: ${error.message}</p>`;
    }
}

function displayTournaments(container, tournaments, isInvitedList) {
    if (!container) return;
    if (tournaments.length === 0) {
        container.innerHTML = isInvitedList ? '<p>No direct tournament invitations found.</p>' : '<p>No open tournaments available right now.</p>';
        return;
    }

    const ul = document.createElement('ul');
    ul.className = 'joinable-tournaments-list';
    tournaments.forEach(tournament => {
        const li = document.createElement('li');
        // TODO: Adjust details based on actual tournament object structure
        li.innerHTML = `
            <span>${tournament.name || `Tournament ID: ${tournament.id.substring(0,6)}...`} (Players: ${tournament.participantsCount || 0}/${tournament.maxPlayers || 'N/A'})</span>
            <button class="btn btn-primary btn-small join-tournament-item-btn" data-tournament-id="${tournament.id}">Join</button>
        `;
        const joinButton = li.querySelector('.join-tournament-item-btn');
        if (joinButton) {
            joinButton.addEventListener('click', async () => {
                await handleJoinTournamentAction(tournament.id);
            });
        }
        ul.appendChild(li);
    });
    container.innerHTML = ''; 
    container.appendChild(ul);
}

async function handleJoinTournamentAction(tournamentId) {
    const auth = getFirebaseAuthService();
    if (!auth || !auth.currentUser) {
        alert("Please sign in to join a tournament.");
        return;
    }
    const functions = getFunctionsService();
    if (!functions) {
        alert("Cannot connect to tournament services.");
        return;
    }

    console.log(`Attempting to join tournament: ${tournamentId}`);
    try {
        // TODO: Replace 'joinTournament' with the actual Firebase Function name
        const joinTournamentFunction = httpsCallable(functions, 'joinTournament'); 
        const result = await joinTournamentFunction({ tournamentId: tournamentId });
        if (result.data && result.data.success) {
            // alert("Successfully joined tournament! It will now appear in your 'Tournaments' tab.");
            closeJoinTournamentModal(); // Close modal on success
            refreshMyTournamentsView();
            // Optionally, trigger a refresh of the main tournaments list on the index page
            // This might require an exported function from index-ui.js or index-main.js
        } else {
            throw new Error(result.data?.message || "Failed to join tournament.");
        }
    } catch (error) {
        console.error("Error joining tournament:", error);
        alert(`Could not join tournament: ${error.message}`);
    }
}

export function openJoinTournamentModal() {
    if (!joinTournamentModalElement) {
        console.error("Join Tournament Modal element not found. Was initJoinTournamentModal called?");
        return;
    }
    joinTournamentModalElement.style.display = 'block';
    fetchJoinableTournaments();
}

function closeJoinTournamentModal() {
    if (joinTournamentModalElement) {
        joinTournamentModalElement.style.display = 'none';
    }
}

export function initJoinTournamentModal() {
    const modalContainer = document.getElementById('joinTournamentModalContainer');
    if (!modalContainer) {
        console.error("Join Tournament Modal container not found in HTML.");
        return Promise.reject("Join Tournament Modal container missing");
    }

    return fetch('/join-tournament-modal.html')
        .then(response => {
            if (!response.ok) throw new Error(`Failed to load join-tournament-modal.html: ${response.statusText}`);
            return response.text();
        })
        .then(html => {
            modalContainer.innerHTML = html;
            assignJoinTournamentModalElements();

            if (!joinTournamentModalElement) {
                console.error("Join Tournament Modal main element not found after loading HTML.");
                return;
            }

            if (closeJoinTournamentModalBtn) {
                closeJoinTournamentModalBtn.addEventListener('click', closeJoinTournamentModal);
            }
            if (refreshJoinableTournamentsBtn) {
                refreshJoinableTournamentsBtn.addEventListener('click', fetchJoinableTournaments);
            }
            joinTournamentModalElement.addEventListener('click', (event) => {
                if (event.target === joinTournamentModalElement) {
                    closeJoinTournamentModal();
                }
            });
            console.log("Join Tournament Modal initialized and listeners attached.");
        })
        .catch(error => {
            console.error('Error initializing Join Tournament Modal:', error);
            if (modalContainer) modalContainer.innerHTML = '<p>Error loading tool to join tournaments. Please try again later.</p>';
        });
} 